import React, {Component, Fragment} from 'react';

import Card from './Card.js';
import Card_old from './Card_old.js';


export const initData ={
    branch : "0",
    lastBranch : "0",

    total : "...",
    total_growth : "0",

    new : "...",
    new_growth : "0",

    renew : "...",
    renew_growth : "0",

    last_total : "...",

    renew_rate : "0",
    new_terminate : 0,
    renew_terminate : 0,
    total_terminate : 0,

    new_terminate_rate : 0,
    renew_terminate_rate : 0,
    total_terminate_rate : 0
    
}


export default class ContractCards extends Component {

	constructor(props) {
        super(props);
        this.state = {
            year : this.props.year,
            ...initData
        }
    }

    componentWillReceiveProps = (nextProps) => {
        
        this.setState({
            branch : nextProps.data.branch,
            lastBranch : nextProps.data.lastBranch,

            total : nextProps.data.total,
            total_growth : nextProps.data.total_growth,

            new : nextProps.data.new,
            new_growth : nextProps.data.new_growth,

            renew : nextProps.data.renew,
            renew_growth :nextProps.data.renew_growth,

            last_total : nextProps.data.last_total,

            renew_rate : nextProps.data.renew_rate,

            new_terminate : nextProps.data.terminate,
            renew_terminate : nextProps.data.renew_terminate,
            total_terminate : nextProps.data.terminate + nextProps.data.renew_terminate,

            new_terminate_rate : Math.ceil( (nextProps.data.terminate / nextProps.data.new ) * 100 ),
            renew_terminate_rate : Math.ceil( (nextProps.data.renew_terminate / nextProps.data.renew ) * 100 ),
            total_terminate_rate : Math.ceil( ((nextProps.data.terminate + nextProps.data.renew_terminate) / nextProps.data.total ) * 100 )
        })
    }

    

	render() {

		return (
			<Fragment>

                <div className="col-xl-10 col-lg-12 col-md-12 col-sm-12 col-12">
                    <div className="row">
                        <div className="col-xl-3 col-lg-6 col-md-12 col-sm-12 col-12">
                            <Card_old title="지사" value={this.state.branch.toLocaleString()} rate={this.state.branch - this.state.lastBranch} isRate={false}/>
                        </div>

                        <div className="col-xl-3 col-lg-6 col-md-12 col-sm-12 col-12">
                            <Card title="전체" value={this.state.total.toLocaleString()} rate={this.state.total_growth} terminate_progress={{"total" :this.state.total, "terminate" : this.state.total_terminate, "rate": this.state.total_terminate_rate}}/>
                        </div>
                        <div className="col-xl-3 col-lg-6 col-md-12 col-sm-12 col-12">
                            <Card title="신규" value={this.state.new.toLocaleString()} rate={this.state.new_growth} terminate_progress={{"total" :this.state.new, "terminate" : this.state.new_terminate, "rate": this.state.new_terminate_rate}}/>
                        </div>
                        <div className="col-xl-3 col-lg-6 col-md-12 col-sm-12 col-12">
                            <Card title="재계약" value={this.state.renew.toLocaleString()} rate={this.state.renew_growth} terminate_progress={{"total" :this.state.renew, "terminate" : this.state.renew_terminate, "rate": this.state.renew_terminate_rate}}/>
                        </div>
                    </div>
                </div>



                
				<div className="col-xl-2 col-lg-12 col-md-12 col-sm-12 col-12">
					<div className="card border-top border-3 border-top-primary">
						<div className="card-body" style={{padding : "10px 20px"}}>
							<h5 className="text-muted">재계약률</h5>
							<div className="metric-value" style={{marginTop : "-5px"}}>
								<h3 className="mb-2" style={{textAlign : "right"}}>{this.state.renew.toLocaleString()} / {this.state.last_total.toLocaleString()}</h3>
                                <div className="progress progress-lg"  style={{background : "#8c8c8c"}}>
                                    <div className="progress-bar" role="progressbar" style={{width: this.state.renew_rate+"%"}} aria-valuenow="25" aria-valuemin="0" aria-valuemax="100">
                                        <span style={{ left: "50%" , position : "absolute"}}>{this.state.renew_rate}%</span>
                                    </div>
                                </div>
							</div>
							
						</div>
					</div>
				</div>
			</Fragment>
		)

	}

}

